const styles = {
  container: {
    padding: '0 !important',
    fontSize: '0.875rem !important',
    color: '#646464 !important',
    fontFamily: 'DOSH !important',
    fontWeight: 'normal !important',
  },
  '@global .ui.table': {
    boxShadow:
      '0 0.0625rem 0 0 rgba(0,0,0,0.03), 0 0.125rem 0.375rem 0 rgba(0,0,0,0.06); !important',
  },
  header: {
    fontSize: '1.25em !important',
    fontWeight: 'normal !important' as 'normal',
    marginTop: '0 !important',
  },
  logo: {
    backgroundColor: '#fff !important',
    border: '.078125em solid #F5F5F5 !important',
    boxSizing: 'border-box !important' as 'border-box',
    height: '2.05937em !important',
    width: '2.15625em !important',
  },
  tableHeader: {
    backgroundColor: '#ffffff !important',
    color: '#646464 !important',
    fontSize: '0.875rem !important',
    fontWeight: 'normal !important',
    fontFamily: 'DOSH !important',
    border: 'none !important;',
    borderBottom: '0.0625rem solid rgba(34,36,38,.1) !important',
  },
  selectableRow: {
    '&:hover': {
      cursor: 'pointer',
    },
  },
  tableCard: {
    display: 'inline-block',
    border: 'black 0.0625rem solid',
    borderRadius: 3,
    padding: '0.0625rem 0.625rem',
    margin: '0 0.0625rem',
  },
  tableCardIcon: {
    height: '1.5em',
    width: '1.5em',
  },
  grayCardIcon: {
    filter: 'grayscale(1)',
  },
  tableCardGray: {
    borderStyle: 'dashed',
    backgroundColor: '#8080802b',
  },
  tableCardRed: {
    backgroundColor: '#fb0909b8',
  },
};

export default styles;
